export class InsertEmpresaRequest{
    usuario : string;
    password : string;
    nombreResponsable : string;
    nombreEmpresa : string;
}